import { Colors } from '../config/default';

// Built at render (not module scope) so a live theme swap re-reads `Colors`.
export const getStyles = () => ({
  title: {
    textAlign: 'center',
    color: Colors.WHITE,
    fontSize: '18px'
  },
  dashedBorderContainer: {
    height: { xs: '65vh', xl: '50vh' },
    overflowY: 'auto',
    margin: '2rem 4rem',
    borderRadius: '10px',
    padding: '1rem',
    border: '3px dashed #5B5B5B'
  },
  innerContent: (loading) => ({
    borderRadius: '10px',
    padding: '1rem 3rem',
    backgroundColor: Colors.SLATE_GREY,
    height: loading ? '100%' : 'auto'
  }),
  loaderContainer: {
    height: 'inherit',
    alignItems: 'center',
    justifyContent: 'center'
  },
  mainContentGrid: {
    height: '98%'
  },
  topRowGrid: {
    justifyContent: 'space-between'
  },
  fileNameTypography: {
    fontSize: { xs: '1em', xl: '1.5em' },
    mt: '.5em',
    color: Colors.TEXTGREY,
    wordBreak: 'break-word',
    textAlign: 'center'
  },
  datePillWrapper: {
    display: 'flex',
    justifyContent: 'center',
    mt: '0.5em',
    mb: '16px'
  },
  datePill: {
    backgroundColor: Colors.DEEP_TEAL,
    color: Colors.TOURQUISE,
    borderRadius: '20px',
    px: 2,
    py: 0.5,
    fontSize: '0.8em',
    fontWeight: 600,
    display: 'inline-block'
  },
  errorContainer: {
    height: '85%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  errorText: {
    fontSize: { xs: '1em', xl: '1.5em', display: 'flex' },
    color: Colors.RED
  },
  errorIcon: {
    mr: 0.5,
    fontSize: '1.4em'
  },
  compareArrowsContainer: {
    height: { xs: '46vh', xl: '32vh' },
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  compareArrowsIcon: {
    fontSize: '3em',
    color: Colors.LIGHTGREY
  },
  documentImage: (isEnlarged, smallScreen) => ({
    marginTop: { xs: '.5em', xl: '' },
    cursor: isEnlarged ? 'zoom-out' : 'zoom-in',
    width: isEnlarged ? 'auto' : '100%',
    objectFit: 'contain',
    height: isEnlarged ? 'auto' : smallScreen ? '50vh' : '40vh'
  }),
  buttonsRow: {
    justifyContent: 'center',
    alignItems: 'center',
    m: '2rem 0em'
  },
  submitButton: {
    backgroundColor: Colors.DEEP_TEAL,
    fontSize: '14px',
    color: Colors.TOURQUISE,
    borderRadius: '20px',
    textTransform: 'none',
    width: '9rem',
    height: '2.5rem',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: Colors.DEEP_TEAL
    }
  },
  emailButtonWrapper: {
    ml: '1.5em'
  },
  deleteButton: {
    backgroundColor: Colors.ROSEWOOD,
    color: Colors.RED,
    borderRadius: '20px',
    fontSize: '14px',
    textTransform: 'none',
    boxShadow: 'none',
    width: '9rem',
    height: '2.5rem',
    ml: '1.5em',
    '&:hover': {
      backgroundColor: Colors.ROSEWOOD
    }
  }
});
